import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranEstimation } from './EcranEstimation.js';

/** Écrans du lot L62, lus par `import.meta.glob('../features/*\/index.{ts,tsx}')` de la coquille. */
export const ecrans: Readonly<Record<string, ComposantEcran>> = { D04c: EcranEstimation };
